import React from "react";
import PropTypes from "prop-types";
import ArenaContents from "arena/components/ArenaContents";
import { useArena } from "core/components/ArenaProvider";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useQuery } from "@apollo/client";
import { ContentPlaylistQuery } from "arena/queries";
import RelatedContentBannerSlot from "arena/components/RelatedContentBannerSlot";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import Link from "arena/components/Link";
// import IconButton from "@mui/material/IconButton";
// import CardHeader from "@mui/material/CardHeader";
// import AppBar from "@mui/material/AppBar";

const VIDEO = "VIDEO";
const STREAM = "STREAM";
const CHANNEL = "CHANNEL";

export default function RelatedContent({
  limit,
  type,
  status,
  relatedContentId,
  selectedContentId,
  productId,
  collectionId,
  isMobile,
  title,
  contentId,
  rightholderId,
  place,
  isAdvEnabled,
}) {
  const arena = useArena();
  const { data, loading } = useQuery(ContentPlaylistQuery, {
    skip: !productId && !collectionId,
    variables: {
      productId: productId || selectedContentId,
      contentId: collectionId || selectedContentId,
      loadContent: !!collectionId,
      loadProduct: !!productId,
    },
  });

  if (loading) return null;

  // const title = (data?.product || data?.content)?.title;
  // const link = (data?.product || data?.content)?.siteUrl;
  const sort = data?.content?.collectionContentSort || "LATEST";

  const showBanner = isAdvEnabled && contentId && rightholderId && place;

  return (
    <>
      {isMobile && showBanner && (
        <RelatedContentBannerSlot
          contentId={contentId}
          rightholderId={rightholderId}
          place={place}
          variant="mobile"
        />
      )}
      {isMobile && title && (
        <Typography
          variant="h6"
          sx={{
            px: { xs: 1.875, sm: 3 },
            pb: 1,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      )}
      <Box sx={isMobile ? { py: 0 } : { p: 0 }}>
        <ArenaContents
          collectionId={collectionId}
          inView
          lg={12}
          limit={limit}
          loadMore
          md={12}
          productId={productId}
          relatedContentId={collectionId || relatedContentId}
          selectedContentId={selectedContentId}
          sm={12}
          sort={sort}
          status={status}
          type={type}
          view="LIST"
          previewMode={arena.defaultPreviewFormat || "HORIZONTAL"}
          xl={12}
          xs={12}
        />
      </Box>
    </>
  );
}

RelatedContent.propTypes = {
  isMobile: PropTypes.bool,
  limit: PropTypes.number,
  type: PropTypes.string,
  status: PropTypes.string,
  relatedContentId: PropTypes.string,
  selectedContentId: PropTypes.string,
  productId: PropTypes.string,
  collectionId: PropTypes.string,
  title: PropTypes.string,
  contentId: PropTypes.string,
  rightholderId: PropTypes.string,
  place: PropTypes.oneOf([VIDEO, STREAM, CHANNEL]),
  isAdvEnabled: PropTypes.bool,
};
